import { WithdrawalReview } from '../../../../investment/components/transfer/WithdrawalReview';

export default function WithdrawalReviewScreen() {
    return <WithdrawalReview />;
}
